<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">工单管理</h1>
			<div class="clear">
		  		<div class="fl">
					<el-button v-if="administrators==1 || administrators==2" @click="showAddCon()"><i class="fa fa-plus"></i> 提交工单 </el-button>
					<el-select class="" v-model="selectCateId" placeholder="请选择工单状态" @change="getDeviceList()">
						<el-option label="全部" key="index" value=""></el-option>
						<el-option v-if="administrators==1 || administrators==2" 
						v-for="(area,index) in cateList" :label="area.ustate" :key="index" :value="area.id"></el-option>
						<el-option v-if="administrators!=1 && administrators!=2"
						v-for="(area,index) in cateList" :label="area.description" :key="index" :value="area.id"></el-option>
					</el-select>
				</div>
		  	</div>
			<br />
			<el-table
		    	stripe
		    	border
			    ref="multipleTable"
			    :data="deviceList"
			    tooltip-effect="dark"
			    style="width: 100%">
			    <el-table-column
			      type="index"
			      width="50">
			    </el-table-column>
			    <el-table-column
			      prop="order"
			      label="编号"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="title"
			      label="标题"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="caption"
			      label="问题分类"
			      show-overflow-tooltip>
			    </el-table-column>
			    
				<el-table-column
			      prop="company"
				  v-if="administrators==3"
			      label="公司">
			    </el-table-column>
			    <el-table-column
			      prop="username"
			      label="提交账号">
			    </el-table-column>
				<el-table-column
					prop="created_time"
					label="提交时间"
					width="90"
					:formatter="dateFormat">
				</el-table-column>
			    <el-table-column
			      prop="urgent"
				  :formatter="forUrgent"
			      label="优先级">
			    </el-table-column>
				<!-- 工单状态分两种：客户和超级管理员 -->
				<el-table-column
					v-if="administrators==1 || administrators==2"
			      prop="ustate"
			      label="工单状态">
			    </el-table-column>
				<el-table-column
					v-if="administrators!=1 && administrators!=2"
			      prop="description"
			      label="工单状态">
			    </el-table-column>
			    <el-table-column
		          label="操作">
		          <template slot-scope="scope">
		            <el-button type="text" size="small"
		                       @click="toDetail(scope.$index, scope.row)">查看 
		            </el-button>
		            <el-button type="text" size="small" v-if="scope.row.state==7 || scope.row.state==8"
		                       @click="showDeleteDia(scope.$index, scope.row)"> 删除
		            </el-button>
					<el-button type="text" size="small" v-if="scope.row.state==7 && administrators!=3"
		                       @click="toDetail(scope.$index, scope.row)"> 评价
		            </el-button>
		          </template>
		        </el-table-column>
			  </el-table>
			<br />
			<div class="text-right">
				<el-pagination
					@current-change="handleCurrentChange"
				  :page-size="pagesize"
				  layout="total, prev, pager, next"
				  :total="totalNum">
				</el-pagination>
			</div>
		</div>
		
	    <!--删除弹框-->
		<el-dialog title="提示" :visible.sync="removeFlag" width="500px" >
		    <div class="userInfo">
				<p>删除后，您将无法恢复和查看该工单，请谨慎操作<br/>
					您确认要删除该工单吗？</p>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="removeFlag = false">取消</el-button>
			    <el-button type="primary" @click="deleteManu()">确定</el-button>
			  </div>
		</el-dialog>
	    <loading v-if="showLoading"></loading>
	</div>  
</template>

<script>
	export default {
		mounted() {
			this.$nextTick(function(){
				this.getStateList();
				this.getDeviceList();
		  	})
    	},
    	data(){
    		return{
    			deviceList:[],
    			nowPage:1,
    			totalNum:0,
				pagesize:12,
				administrators:this.getCookie("administrators"),
    			formLabelWidth:'110px',
       			showLoading:false,
       			removeFlag:false,
       			manufac:{
       				name:"",
	       			contacts:"",
	       			email:"",
	       			tel:"",
	       			website:"",
	       			is_enabled:""
       			},
				cateList:[],
				selectCateId:null
       			
    		}
    	},
    	methods:{
			
    		getDeviceList(){
    			this.showLoading = true;
				let valiCodeParams={
					uid:this.getCookie('uid'),
					state:this.selectCateId || '',
					page:this.nowPage,
					pagesize:this.pagesize,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Wordermanage/list",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		this.deviceList = res.data.data.datalist || [];
		        		this.totalNum = res.data.data.totalNumber;
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
			// 获取工单状态列表
			getStateList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					page:this.nowPage,
					pagesize:this.pagesize,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Wordermanage/worderstateall",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code=="200"){
		        		this.cateList = res.data.data || [];
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
			//			分页点击事件
			handleCurrentChange(val){
				this.nowPage = val;
				this.getDeviceList();
			},
			showAddCon(){
				let routeUrl = this.$router.resolve({
					path: "/newOrder",
				});
				window.open(routeUrl.href, '_blank');
			},
			toDetail(index,row){
				let routeUrl = this.$router.resolve({
					path: "/rightPanel/repairDetail",
					query: {
						id:row.id,
						index:index
					}
				});
				window.open(routeUrl.href, '_blank');
			},

			showDeleteDia(index,row){
				this.removeFlag = true;
				this.manufac = row
			},
			deleteManu(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					id:this.manufac.id,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Wordermanage/del",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code=="200"){
		        		this.removeFlag = false;
		        		this.getDeviceList();
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
			showModifyDia(index,row){
				this.manufac = row;
			},
			modifyManu(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					id:this.manufac.id,
					name:this.manufac.name,
					contacts:this.manufac.contacts,
					email:this.manufac.email,
					tel:this.manufac.tel,
					website:this.manufac.website,
					is_enabled:this.manufac.is_enabled,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Manufacturer/UpdateManufacturer",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		this.$message.success(res.data.msg);
		        		this.getDeviceList();
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
    	}
   }
</script>

<style>
	.search-box2{margin-top: -69px;}
</style>


// WEBPACK FOOTER //
// src/components/rightPanel/repairOrderPub.vue